(function initNuNuvotonTableEnhancements() {
  if (window.NuCollectionR4QBooted) return;
  window.NuCollectionR4QBooted = true;

  function getR4QMode() {
    const layoutEl = document.querySelector('.nu--collection-layout');
    const mode = String(layoutEl?.dataset?.nuQuoteMode || '').trim().toLowerCase();
    return mode || 'bss';
  }

  function isR4QEnabled() {
    const mode = getR4QMode();
    return mode === 'bss';
  }

  function useNativeR4QPlacement() {
    const layoutEl = document.querySelector('.nu--collection-layout');
    return layoutEl?.dataset?.nuR4qNative === 'true';
  }

  let nativeR4QRefreshTimer = null;
  let nativeR4QRefreshInProgress = false;
  let nativeR4QPendingRefresh = null;
  let nativeR4QLastRowsSignature = '';
  let nativeR4QLastLoadAt = 0;
  let nativeR4QRefreshCount = 0;

  function isDevPerfLogEnabled() {
    const layoutEl = document.querySelector('.nu--collection-layout');
    if (layoutEl?.dataset?.nuPerfLog === 'true') return true;
    if (window.Shopify?.designMode) return true;
    return /preview_theme_id=/.test(window.location.search);
  }

  function formatMs(value) {
    return `${Math.round(value * 100) / 100}ms`;
  }

  function perfNow() {
    if (typeof window.performance?.now === 'function') return window.performance.now();
    return Date.now();
  }

  function dispatchR4QRefreshDone(version) {
    document.dispatchEvent(new CustomEvent('nu:r4q:refresh:done', {
      detail: { version },
    }));
  }
  function getR4QRowsSignature(tableRoot) {
    if (!tableRoot) return '';
    return Array.from(tableRoot.querySelectorAll('tr[data-product-id]'))
      .map((rowEl) => rowEl.getAttribute('data-product-id') || '')
      .filter(Boolean)
      .join('|');
  }

  function createNativeR4QWrapper(productId) {
    const wrapper = document.createElement('bcp-r4q-button-wrapper');
    wrapper.setAttribute('page', 'collection');
    wrapper.setAttribute('data-product-id', String(productId || ''));
    return wrapper;
  }

  function getRowCollectionWrappers(rowEl, productId) {
    if (!rowEl) return [];
    const expectedProductId = String(productId || '');
    return Array.from(rowEl.querySelectorAll('bcp-r4q-button-wrapper[page="collection"]')).filter((wrapperEl) => {
      const wrapperProductId = String(wrapperEl.getAttribute('data-product-id') || '');
      return !expectedProductId || !wrapperProductId || wrapperProductId === expectedProductId;
    });
  }

  function patchNativeR4QSlots(tableRoot) {
    if (!tableRoot) {
      return { changed: false, slots: 0, created: 0, removed: 0 };
    }

    let created = 0;
    let removed = 0;
    let changed = false;
    const slotElements = Array.from(tableRoot.querySelectorAll('[data-nu-r4q-slot]'));
    slotElements.forEach((slotEl) => {
      const rowEl = slotEl.closest('tr[data-product-id]');
      const productId = slotEl.getAttribute('data-product-id') || rowEl?.getAttribute('data-product-id') || '';
      if (!productId) return;

      const wrappers = getRowCollectionWrappers(rowEl, productId);
      let keepWrapper = wrappers.find((wrapperEl) => (
        (wrapperEl.getAttribute('page') || 'collection') === 'collection'
        && ((wrapperEl.getAttribute('data-product-id') || '') === String(productId) || !wrapperEl.getAttribute('data-product-id'))
      ));
      if (!keepWrapper) keepWrapper = wrappers[0] || null;

      if (!keepWrapper) {
        keepWrapper = createNativeR4QWrapper(productId);
        slotEl.prepend(keepWrapper);
        created += 1;
        changed = true;
      }

      if (keepWrapper.getAttribute('page') !== 'collection') {
        keepWrapper.setAttribute('page', 'collection');
        changed = true;
      }
      if (keepWrapper.getAttribute('data-product-id') !== String(productId)) {
        keepWrapper.setAttribute('data-product-id', String(productId));
        changed = true;
      }
      if (keepWrapper.parentElement !== slotEl) {
        slotEl.prepend(keepWrapper);
        changed = true;
      }

      wrappers.forEach((wrapperEl) => {
        if (wrapperEl !== keepWrapper) {
          wrapperEl.remove();
          removed += 1;
          changed = true;
        }
      });
    });

    return {
      changed,
      slots: slotElements.length,
      created,
      removed,
    };
  }

  function normalizeNativeR4QSlots(tableRoot) {
    if (!tableRoot) {
      return { changed: false, cleaned: 0 };
    }

    let cleaned = 0;
    let changed = false;
    tableRoot.querySelectorAll('[data-nu-r4q-slot] bcp-r4q-button-wrapper').forEach((wrapperEl) => {
      wrapperEl.querySelectorAll('.bcp-r4q-show-price, .bcp-r4q-show-add-cart, .bcp-r4q-show-buy-now').forEach((legacyEl) => {
        legacyEl.remove();
        cleaned += 1;
        changed = true;
      });
      const buttonMainEls = Array.from(wrapperEl.querySelectorAll('bcp-r4q-button-main'));
      if (buttonMainEls.length > 1) {
        buttonMainEls.forEach((buttonMainEl, index) => {
          if (index < buttonMainEls.length - 1) {
            buttonMainEl.remove();
            cleaned += 1;
            changed = true;
          }
        });
      }
    });

    return { changed, cleaned };
  }

  async function refreshNativeR4Q({ reason = 'unknown', force = false, version = 0 } = {}) {
    if (!isR4QEnabled() || !useNativeR4QPlacement()) return;
    if (nativeR4QRefreshInProgress) {
      nativeR4QPendingRefresh = { reason, force, version };
      return;
    }
    nativeR4QRefreshInProgress = true;
    const refreshId = ++nativeR4QRefreshCount;
    const refreshStartAt = perfNow();
    let patchElapsed = 0;
    let normalizeElapsed = 0;
    let loadElapsed = 0;
    let loaded = false;
    let skippedLoad = false;
    let patchStats = { changed: false, slots: 0, created: 0, removed: 0 };
    let normalizeStats = { changed: false, cleaned: 0 };
    try {
      const tableRoot = document.querySelector('.nu--collection-layout .nu-products-table');
      const rowsSignature = getR4QRowsSignature(tableRoot);

      const patchStartAt = perfNow();
      patchStats = patchNativeR4QSlots(tableRoot);
      patchElapsed = perfNow() - patchStartAt;

      const normalizeStartAt = perfNow();
      normalizeStats = normalizeNativeR4QSlots(tableRoot);
      normalizeElapsed = perfNow() - normalizeStartAt;

      const rowsChanged = rowsSignature !== nativeR4QLastRowsSignature;
      nativeR4QLastRowsSignature = rowsSignature;

      const loadData = window.BSS_BCP_V2?.r4q?.loadShopifyData;
      const shouldLoad = force
        || rowsChanged
        || patchStats.changed
        || normalizeStats.changed
        || (Date.now() - nativeR4QLastLoadAt > 5000);
      if (typeof loadData === 'function' && shouldLoad) {
        const loadStartAt = perfNow();
        await loadData();
        loadElapsed = perfNow() - loadStartAt;
        nativeR4QLastLoadAt = Date.now();
        loaded = true;
      } else {
        skippedLoad = true;
      }

      if (isDevPerfLogEnabled()) {
        const totalElapsed = perfNow() - refreshStartAt;
        console.debug(
          `[nu-r4q][perf#${refreshId}] reason=${reason}`
          + ` patch=${formatMs(patchElapsed)}`
          + ` normalize=${formatMs(normalizeElapsed)}`
          + ` loadShopifyData=${loaded ? formatMs(loadElapsed) : (skippedLoad ? 'skip' : 'n/a')}`
          + ` total=${formatMs(totalElapsed)}`,
          {
            slots: patchStats.slots,
            createdWrappers: patchStats.created,
            removedWrappers: patchStats.removed,
            cleanedWrappers: normalizeStats.cleaned,
            force,
          }
        );
      }
    } finally {
      nativeR4QRefreshInProgress = false;
      dispatchR4QRefreshDone(version);
      if (nativeR4QPendingRefresh) {
        const pending = nativeR4QPendingRefresh;
        nativeR4QPendingRefresh = null;
        scheduleNativeR4QRefresh(80, { reason: 'pending', force: pending.force, version: pending.version });
      }
    }
  }

  function scheduleNativeR4QRefresh(delay = 120, options = {}) {
    if (!isR4QEnabled() || !useNativeR4QPlacement()) return;
    if (nativeR4QRefreshTimer) window.clearTimeout(nativeR4QRefreshTimer);
    nativeR4QRefreshTimer = window.setTimeout(() => {
      nativeR4QRefreshTimer = null;
      refreshNativeR4Q(options);
    }, delay);
  }

  // The BSS app-embed script registers window.BSS_BCP_V2 asynchronously and there's
  // no whenDefined()-style hook for a plain global, so refreshNativeR4Q's very first
  // attempt can silently no-op if it runs before that script is ready. Poll until it
  // shows up and guarantee one more load attempt then, instead of relying only on
  // whatever other event happens to fire next (e.g. nu:spec-filters:ready, which on
  // mobile is now deferred until the filter drawer is first opened and may not fire
  // at all in a given session).
  function waitForNativeR4QReady() {
    if (!isR4QEnabled() || !useNativeR4QPlacement()) return;
    const maxAttempts = 30;
    let attempts = 0;
    const poll = () => {
      attempts += 1;
      if (typeof window.BSS_BCP_V2?.r4q?.loadShopifyData === 'function') {
        scheduleNativeR4QRefresh(0, { reason: 'bss-ready', force: true });
        return;
      }
      if (attempts >= maxAttempts) {
        if (isDevPerfLogEnabled()) {
          console.debug('[nu-r4q] gave up waiting for window.BSS_BCP_V2.r4q.loadShopifyData');
        }
        return;
      }
      window.setTimeout(poll, 500);
    };
    poll();
  }

  (function enableDevPerfLogOnHotReload() {
    if (isDevPerfLogEnabled()) return;
    const hasHotReloadScript = Boolean(document.querySelector('script[src*="theme-hot-reload"]'));
    if (!hasHotReloadScript) return;
    const layoutEl = document.querySelector('.nu--collection-layout');
    if (!layoutEl) return;
    layoutEl.dataset.nuPerfLog = 'true';
  })();

  document.addEventListener('nu:spec-filters:ready', () => {
    scheduleNativeR4QRefresh(220, { reason: 'spec-filters-ready' });
  });
  document.addEventListener('nu:r4q:refresh', (event) => {
    const refreshVersion = Number(event?.detail?.version || 0);
    scheduleNativeR4QRefresh(80, { reason: 'nu-r4q-refresh', version: refreshVersion });
  });

  if (isR4QEnabled() && useNativeR4QPlacement()) {
    scheduleNativeR4QRefresh(40, { reason: 'initial' });
    waitForNativeR4QReady();
  }
})();
